/*
 * View for inspecting and changing the daily refresh schedule of a KB
 */

define(["marionette", "./template/kbDailyRefreshTemplate.html"], function (
  Marionette,
  KbDailyRefreshTemplate,
) {
  var KbDailyRefreshView = {};

  KbDailyRefreshView.kbDailyRefreshView = Marionette.ItemView.extend({
    template: KbDailyRefreshTemplate,
    modelEvents: {
      sync: "render",
    },
    events: {
      "click #enableDailyRefresh": function () {
        var isChecked = this.$el.find("#enableDailyRefresh").prop("checked");
        //if the checkbox is checked, enable the time select.  Otherwise disable the select.
        this.$el.find("#refreshTime").prop("disabled", !isChecked);

        this.trigger("toggle:daily:refresh", isChecked);
      },
      "change #refreshTime": function () {
        //parseInt makes sure that the returned value is a number, not a string
        var optionSelected = this.$el.find("#refreshTime option:selected").val();
        var optionSelectedNumber = parseInt(optionSelected, 10);
        this.trigger("change:refresh:time", optionSelectedNumber);
      },
    },
  });

  return KbDailyRefreshView;
});
